!function(root, app) {
    app.events = app.events || {};
    app.events.winterWonderland = app.events.winterWonderland || {};
    app.events.winterWonderland = {
        init: function() {
            this.defineProps();
            this.setupOverviewParallax();
        },
        defineProps: function() {
            //page containers and elements
            this.$eventLogoContainer = $('[data-js="event-logo"]');
            this.$eventOverviewBackgroundImage = $('[data-js="event-overview-background-image"]');
            this.$eventOverviewForegroundImageLeft = $('[data-js="event-overview-foreground-image-left"]');
            this.$eventOverviewForegroundImageRight = $('[data-js="event-overview-foreground-image-right"]');
            this.$eventOverviewPlayIcon = $('[data-js="overview-play-button"]');
        },
        setupOverviewParallax: function() {
            this.$eventLogoContainer.verticalParallax(.25);
            this.$eventOverviewBackgroundImage.verticalParallax(.9);
            this.$eventOverviewForegroundImageLeft.verticalParallax(.8);
            this.$eventOverviewForegroundImageRight.verticalParallax(.7);
            this.$eventOverviewPlayIcon.verticalParallax(.5);
        }
    };
}(this, this.app);
